"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChromeBrowser = exports.isFirefoxBrowser = exports.isSafariBrowser = exports.isSafariIOS = exports.isIOS = exports.isBrowser = exports.SupportedBrowser = void 0;
const bowser_1 = __importDefault(require("bowser"));
var SupportedBrowser;
(function (SupportedBrowser) {
    SupportedBrowser["SAFARI"] = "safari";
    SupportedBrowser["CHROME"] = "chrome";
    SupportedBrowser["FIREFOX"] = "firefox";
})(SupportedBrowser = exports.SupportedBrowser || (exports.SupportedBrowser = {}));
const isBrowser = (browserString) => {
    const browser = bowser_1.default.getParser(window.navigator.userAgent);
    const checkTree = {
        safari: '>0',
        firefox: '>0'
    };
    const current = [];
    // Safari and Firefox do not implement at all the permissions query for microphone (and camera)
    // mozilla Firefox developers explanations: https://github.com/mozilla/standards-positions/issues/19#issuecomment-370087341
    if (browser.satisfies(checkTree)) {
        current.push(SupportedBrowser.SAFARI);
        current.push(SupportedBrowser.FIREFOX);
    }
    return current.includes(browserString);
};
exports.isBrowser = isBrowser;
const isIOS = () => {
    const browser = bowser_1.default.getParser(window.navigator.userAgent);
    return browser.getOS().name === 'iOS';
};
exports.isIOS = isIOS;
const isSafariIOS = () => {
    const browser = bowser_1.default.getParser(window.navigator.userAgent);
    return browser.getOS().name === 'iOS' && browser.getBrowserName() === 'safari';
};
exports.isSafariIOS = isSafariIOS;
const isSafariBrowser = () => exports.isBrowser(SupportedBrowser.SAFARI);
exports.isSafariBrowser = isSafariBrowser;
const isFirefoxBrowser = () => exports.isBrowser(SupportedBrowser.FIREFOX);
exports.isFirefoxBrowser = isFirefoxBrowser;
const isChromeBrowser = () => exports.isBrowser(SupportedBrowser.CHROME);
exports.isChromeBrowser = isChromeBrowser;
